<app-offcanvas-sheet
  [visible]="visible"
  [title]="title"
  saveLabel="Save Order"
  (closeCanvas)="onClose()"
  (save)="onSave()">

  <!-- Product -->
  <div class="form-group-mobile">
    <label>Product</label>
    <app-single-select-dropdown
      [options]="productsOptions"
      [selectedValue]="formData.finishedGoodItemID != null ? formData.finishedGoodItemID.toString() : null"
      placeholder="Select product"
      (selectedValueChange)="onProductSelectChange($event)">
    </app-single-select-dropdown>
  </div>

  <!-- Quantity -->
  <div class="form-group-mobile">
    <label>Quantity to Produce</label>
    <input type="number" class="form-control" [(ngModel)]="formData.quantityToProduce" (ngModelChange)="onQuantityChange()" placeholder="1" min="1">
  </div>

  <!-- Dates -->
  <div class="form-row-2">
    <div class="form-group-mobile">
      <label>Start Date</label>
      <input type="date" class="form-control" [(ngModel)]="formData.plannedStartDate">
    </div>
    <div class="form-group-mobile">
      <label>End Date</label>
      <input type="date" class="form-control" [(ngModel)]="formData.plannedEndDate">
    </div>
  </div>

  <!-- Notes -->
  <div class="form-group-mobile">
    <label>Notes</label>
    <textarea class="form-control" rows="2" [(ngModel)]="formData.notes" placeholder="Optional notes"></textarea>
  </div>

</app-offcanvas-sheet>
